<template>
  <layout class="password">
    <div class="title">
      <div>
        {{ type === "register" ? "设置密码" : "重置密码" }}
      </div>
    </div>
    <el-form ref="form" :model="form" :rules="rules" label-width="0">
      <el-form-item class="custom-input" prop="password">
        <span class="svg-container">
          <svg-icon icon-class="login-password" />
        </span>
        <el-input show-password v-model="form.password"></el-input>
      </el-form-item>
      <el-form-item class="custom-input" prop="passwordR">
        <span class="svg-container">
          <svg-icon icon-class="login-password" />
        </span>
        <el-input show-password v-model="form.passwordR"></el-input>
      </el-form-item>
    </el-form>
    <base-button class="main-btn big-btn" :loading="loading" type="primary" @click="submit">
      保存并登录
    </base-button>
  </layout>
</template>
<script>
import Layout from "@/views/Login/Layout"
import BaseButton from "@/components/UIComponents/Button"
import * as UserApi from "@/api/user"

export default {
  name: "Password",
  components: { BaseButton, Layout },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"))
      } else if (!/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,16}$/.test(value)) {
        callback(new Error("密码需为8--16位字母、数字或特殊符合至少两种组合"))
      }
      callback()
    }
    let validatePassR = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"))
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"))
      }
      callback()
    }
    return {
      form: {
        password: "",
        passwordR: ""
      },
      rules: {
        password: [{ validator: validatePass, trigger: "change" }],
        passwordR: [{ validator: validatePassR, trigger: "change" }]
      },
      loading: false,
      type: this.$route.query.type,
      codeVerifyForm: {}
    }
  },
  mounted() {
    let codeVerifyFormStr = localStorage.getItem("codeVerifyForm")
    if (!codeVerifyFormStr) {
      this.$message.error("页面缺少参数")
      this.$router.push("login")
      return
    }
    this.codeVerifyForm = JSON.parse(codeVerifyFormStr)
  },
  methods: {
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        let reqFunc = this.type === "register" ? UserApi.registerUser : UserApi.forceChangePassword
        reqFunc(
          this.codeVerifyForm.telephone,
          encodeURIComponent(this.form.password),
          this.codeVerifyForm.verifyCode
        ).then(() => {
          this.$message.success("操作成功")
          this.$router.push({ name: "login" })
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.password {
  .title {
    text-align: center;
    font-size: 34px;
    font-weight: bold;
    color: #1989fa;
    line-height: 48px;
    margin: 8px 0 64px;
  }
  .el-form-item {
    margin-bottom: 24px;
  }
  .svg-container {
    position: absolute;
    top: 3px;
    left: 12px;
    color: #dcdfe6;
    vertical-align: middle;
    width: 15px;
    z-index: 1;
  }
}
</style>
